<template>
  <div id="app">
    <KitchenDisplay />
  </div>
</template>

<script>
import KitchenDisplay from './components/KitchenDisplay.vue';

export default {
  name: 'App',
  components: { KitchenDisplay },
};
</script>

<style>
html, body, #app {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #f4f4f4;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}
</style>